import api from "./axios";

export const getMaterials = () =>
  api.get("/materials");

export const createMaterial = (data) =>
  api.post("/materials", data);

export const updateMaterial = (id, data) =>
  api.put(`/materials/${id}`, data);

export const deleteMaterial = (id) =>
  api.delete(`/materials/${id}`);